import React, { useState } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import commonStyles from "css/common.module.css";
import widgetStyles from "css/widgets.module.css";
import UIFooter from "components/UI/Footer";
import UIButtonSecondary from "components/UI/Button/Secondary";
import { history } from "store";
import PdfRenderer from "./PdfRenderer/PdfRenderer";
import { selectAccessToken } from "selector/authSelectors";
import Tablist from "containers/home/WorkList/TabList/Tablist";

const PDF_TYPES = {
  DUAL: { value: "dual", text: "Dual" },
  INSURER: { value: "insurer", text: "Insurer Retained" },
  OWNER: { value: "owner", text: "Owner Retained" },
  ALL: { value: "full", text: "Combined" }
};

const PDF_TYPES_TABLIST = Object.values(PDF_TYPES).map(val => val.text);
const getTypeByText = text =>
  Object.values(PDF_TYPES).find(type => type.text === text);
const getTypeByValue = value =>
  Object.values(PDF_TYPES).find(type => type.value === value);

const Container = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;

  && {
    padding: 0 0 84px;
  }

  .pdf-viewer {
    width: 100%;
  }

  .tabs {
    background: var(--white);
    height: 60px;
    z-index: 2;
  }
`;

const FeesPDF = ({ match, token, location }) => {
  const { workItemId } = match.params;
  const { isDual, type } = location.state;

  const [pdfType, setPdfType] = useState(getTypeByValue(type));

  return (
    <Container className={`${commonStyles.flexPadded} ${commonStyles.page}`}>
      {isDual ? (
        <Tablist
          className="tabs"
          items={PDF_TYPES_TABLIST}
          activeItem={pdfType.text}
          onChange={text => setPdfType(getTypeByText(text))}
        />
      ) : null}

      <PdfRenderer workItemId={workItemId} type={pdfType.value} token={token} />

      <UIFooter className={widgetStyles.btnFooter} style={{ left: 0 }}>
        <UIButtonSecondary
          id="backToSummary"
          className={widgetStyles.btnFooter__button}
          onClick={() => history.goBack()}
        >
          Back to Summary
        </UIButtonSecondary>

        <UIButtonSecondary
          id="backToWorkListPDF"
          className={widgetStyles.btnFooter__button}
          onClick={() => history.push("/")}
        >
          Back to Worklist
        </UIButtonSecondary>
      </UIFooter>
    </Container>
  );
};

export default connect(state => ({ token: selectAccessToken(state) }))(FeesPDF);
